export class Video {
  id:number;
  lien:any;
}
